// 講師セレクト（1役割ぶん）の描画。_lecturer_select.blade.php と同じマークアップを出す

import { classNames, esc } from './html'

const SELECT_CLASSES = 'ring-gray-300 focus:ring-indigo-600 block w-[160px] text-xs my-auto h-6 rounded-md border-0 py-0.5 text-gray-900 shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset'

/**
 * @param {object} lesson API の online_lessons の要素
 * @param {'lecturer_user_id'|'support_lecturer_user_id'|'observer_lecturer_user_id'} roleKey
 * @param {boolean} marksCertified 認定講師に「(認定)」を付けるか（メイン講師のみ）
 * @returns {string}
 */
export const renderLecturerSelect = (lesson, roleKey, marksCertified) => {
    const name = `online_lesson_settings[${lesson.id}][${roleKey}]`
    const assigned = lesson.assigned[roleKey]

    // 講師が設定済みで、選択可能な講師に存在しないときは、テキストで講師名を表示し hidden で値を保持する
    if (assigned && !assigned.is_selectable) {
        return `${esc(assigned.full_name)}<input type="hidden" name="${esc(name)}" value="${esc(assigned.id)}">`
    }

    const options = lesson.selectable_lecturers.map((lecturer) => {
        const selected = assigned && assigned.id === lecturer.id ? ' selected' : ''
        const label = `${lecturer.availability ?? ''}${lecturer.full_name}${marksCertified && lecturer.is_certified ? '(認定)' : ''}`

        return `<option value="${esc(lecturer.id)}"${selected} class="${classNames(lecturer.is_overlapping && 'text-red-500')}">${esc(label)}</option>`
    })

    return `<select name="${esc(name)}" class="${SELECT_CLASSES}"><option value="">-</option>${options.join('')}</select>`
}
